export var getDevicePrice = function (monthlyPrice, upfrontPrice, basePrice) {
    if (monthlyPrice || monthlyPrice === 0)
        return Math.round(100 * monthlyPrice) / 100;
    if (typeof upfrontPrice === 'number')
        return upfrontPrice;
    if (typeof basePrice === 'number')
        return basePrice;
    return 0;
};
